/**
 * Canonical mapping of TTS voice IDs to gender presentation.
 * Single source of truth consumed by voice assignment (server),
 * face-tile selection (client), and any future gender-aware logic.
 */
export const FEMALE_VOICES = ['nova', 'shimmer'];
export const MALE_VOICES = ['echo', 'fable', 'onyx'];
export const NEUTRAL_VOICES = ['alloy'];
export const VOICE_TO_GENDER = {
    nova: 'female',
    shimmer: 'female',
    echo: 'male',
    fable: 'male',
    onyx: 'male',
};
//# sourceMappingURL=voiceGenderMap.js.map